<template>
  <base-dialog
    :action="onAction"
    :action-name="'Add Card'"
    :close="onClose"
    :title="'Add Card'"
  >
    <template #activator="{ on }">
      <slot
        name="activator"
        v-bind="{ on }"
      />
    </template>

    <template #content>
      <stripe-card-input
        :is-platform="isPlatform"
        ref="stripeInput"
      />

      <v-expansion-panels v-model="moreOptions">
        <v-expansion-panel>
          <v-expansion-panel-header>More Options</v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-text-field
              outlined
              dense
              v-model="model.name"
              label="Cardholder Name"
            />

            <v-text-field
              outlined
              dense
              v-model="model.address_line1"
              label="Address Line 1"
            />

            <v-text-field
              outlined
              dense
              v-model="model.address_line2"
              label="Address Line 2"
            />

            <v-text-field
              outlined
              dense
              v-model="model.address_state"
              label="Province / State"
            />

            <v-text-field
              outlined
              dense
              v-model="model.address_zip"
              label="Postal Code / ZIP"
            />

            <v-text-field
              outlined
              dense
              v-model="model.address_city"
              label="Address City"
            />

            <v-text-field
              outlined
              dense
              v-model="model.address_country"
              label="Address Country"
            />
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </template>
  </base-dialog>
</template>
<style>
  .v-expansion-panel, .v-expansion-panels {
    box-shadow: none;
  }
</style>
<script>
import { mapActions } from 'vuex'
import BaseDialog from "../Common/BaseDialog"
import StripeCardInput from "../Common/StripeCardInput"
import { isErrorResponse } from "../../services/util.service"

export default {
  components: {
    BaseDialog,
    StripeCardInput
  },
  props: {
    isPlatform: {
      type: Boolean,
      default: false,
    },
    customerId: {
      type: String,
      default: () => this.$route.params.id.startsWith('cus_') ? this.$route.params.id : ''
    },
  },
  data() {
    return {
      model: {
        billing_details: {
          address: {
            city: null,
            country: null,
            line1: null,
            line2: null,
            postal_code: null,
            state: null,
          },
          email: null,
          name: null,
          phone: null
        },
      },
      moreOptions: false
    }
  },
  mounted() {

  },
  methods: {
    ...mapActions([
      'createCustomerPaymentMethod',
      'updateCustomerPaymentMethod'
    ]),
    onClose() {
      this.$emit('close')
    },
    onAction() {
      let actionPayload = null
      // This is hacky, but Stripes Input is a unique situation

      const onAfterToken = tokenObj => {
        const { id: tokenId } = tokenObj

        const createPayload = {
          type: 'card',
          card: { token: tokenId },
          customer: this.customerId
        }

        if (this.isPlatform) {
          createPayload._headers = { 'x-account': '' }
        }

        return this.createCustomerPaymentMethod(createPayload)
          .then(card => {

            if (!isErrorResponse(card)) {
              const { id: cardId } = card
              const updatePayload = {
                id: cardId,
                customer: this.customerId,
                ...this.model
              }

              if (this.isPlatform) {
                updatePayload._headers = { 'x-account': '' }
              }

              return this.updateCustomerPaymentMethod(updatePayload)
                .then(res => {
                  if (!isErrorResponse(res)) {
                    this.$emit('action', card)
                  }

                  return res
                })
            } else {
              return card
            }
          })
      }

      return this.$refs.stripeInput.createToken()
        .then(onAfterToken)
    }
  }
}
</script>
